<template>
	<div class="documentation">
		<div class="header">
			<div class="float-left">
				<h3>{{ i18n.title }}</h3>
			</div>
			<div class="float-right">
				<a href="https://postmansmtp.com/documentation/?utm_source=dashboard&utm_medium=documentation&utm_campaign=plugin">{{ i18n.viewAll }}</a>

				<a
					href="#"
					@click="e => toggleTransition( e )"
					style="box-shadow: none;border: none;outline: none;"
				>
					<img
						class="transform-image maximize"
						style="margin-left: 10px;"
						:src="plugin_dir_url + 'assets/images/maximize.png'"
					>
				</a>
			</div>
		</div>

		<transition
			name="fade"
			enter-active-class="animated slideIn"
		>
			<div v-if="show_documentation" class="body">
				<div class="content">
					<post-smtp-documentation
						v-for="doc in documentation" :key="doc.title"
						:title="doc.title"
						:docs-links="doc.links"
						:view-more="doc.view_more"
						:plugin-dir-url="plugin_dir_url"
						:admin-url="admin_url"
					></post-smtp-documentation>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'PostSMTPGuide',

	data: ( vm ) => ( {
    i18n: postSmtpNewDashboard.i18n.documentation,
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
		documentation: postSmtpNewDashboard.i18n.documentation.documentation,
		show_documentation: true,
	} ),

	methods: {
		toggleTransition( e ) {
			e.preventDefault();
			const image = document.querySelector( '.transform-image' );
			image.classList.toggle( 'minimize' );

			this.show_documentation = ! this.show_documentation;
		}
	}
}
</script>

<style scoped>
.documentation * {
	padding: 0;
	margin: 0;
}
.header {
	border-radius: 4px 4px 0 0;
	border-width: 1px 1px 0 1px;
	border-style: solid;
	border-color: #DCDFE5;
	padding: 16px 24px;
	background: #FFFFFF;
}

.header h3 {
	font-family: Poppins;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	text-align: left;
	color: #231F20;
}

.float-left {
	float: left;
}

.float-right {
	float: right;
}

.header::after {
	content: '';
	display: block;
	clear: both;
}

.transform-image {
	transform: rotate(0deg);
	transition: transform 0.5s;
}

.maximize {
	transform: rotate(180deg);
}

.minimize {
	transform: rotate(0deg);
}

.body {
	background: #EFF4FD;
	border-width: 0 1px 1px 1px;
	border-style: solid;
	border-color: #DCDFE5;
	padding: 48px 0;
}

.body {
	width: calc( 100% - 2px );
	display: flex;
	justify-content: center;
	align-items: center;
}

.content {
	display: grid;
	grid-template-columns: auto auto auto;
}

.content::after {
	content: '';
	display: block;
	clear: both;
}
</style>